/**
 * Push route navigations to analytics.js.
 * 
 * TODO: Upgrade to router to v4 to prvent double firing page events.
 * See issue: https://github.com/ReactTraining/history/issues/427#issuecomment-282787857
 * 
 * @param history {object}
 */
export const trackPages = history => {
  history.listen(location => {
    if (window.analytics) {
      window.analytics.page();
    }
  });
};



/** WEBPACK FOOTER **
 ** ./src/_shared/lib/page-tracker/index.js
 **/